export class PracticeInfo {
  id?: number;
  name: string;
  dbaName?: string;
  contactPersonName?: string;
  contactPhone: string;
  contactEmail: string;
  address1: string;
  address2?: string | null = null;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
  logoUrl?: string;
  isAccountDetailsSaved?: boolean;
  status?:number;
  reason?:string;
  pmsId? : number;
}

export class Practice {
  id?: number;
  customerId?: number;
  accountId?: number;
  solutionId?: number;
  name: string = '';
  dbaName?: string = '';
  logoUrl?: string | null = null;
  contactPersonName: string = '';
  contactPhone: string = '';
  contactEmail?: string = '';
  isActive?: boolean = false;
  activationKey?: string;
  createdOn?: string;
  extractorInstalledDate?: string;
  timezoneOffset?: string;
  extractorVersion?: string;
  tenantDBName?: string;
  address1: string;
  address2?: string = '';
  city: string;
  state: string;
  zipcode: string;
  country: string;
  pmsId: number;
  pmsName?: string;
  pmsPracticeId?: string | null = null;
  ipAddress?: string | null = null;
  taxId?: string;
  legalEntityName?: string;
  email?: string;
  dcsCustomerId?: string;
  makePracticeEmailIdTheLoginId?: boolean = false;
  monOpenTime?: string | null = null;
  monCloseTime?: string | null = null;
  tuesOpenTime?: string | null = null;
  tuesCloseTime?: string | null = null;
  wedOpenTime?: string | null = null;
  wedCloseTime?: string | null = null;
  thursOpenTime?: string | null = null;
  thursCloseTime?: string | null = null;
  friOpenTime?: string | null = null;
  friCloseTime?: string | null = null;
  satOpenTime?: string | null = null;
  satCloseTime?: string | null = null;
  sunOpenTime?: string | null = null;
  sunCloseTime?: string | null = null;
  serverIPAddress?: string = '';
  phone?: string = '';
  contactPersonTitle?: string = '';
  code?: string = '';

  isAgreementAccepted?: boolean = false;

  agreementStatus?: number = 0;
  agreementDate?: Date | string | null | undefined = null;
  agreementAcceptedOrRejectedBy?: number = 0;
  agreementAcceptedOrRejectedByByName?: string;
  agreementStartDate?: Date | string | null | undefined = null;
  agreementEndDate?: Date | string | null | undefined = null;
  firstBillingDate?: Date | string | null | undefined = null;

  reminderDate?: Date | string | null | undefined = null;
  remindedBy?: number  = 0;
  remindedByName?: string;

  isTenantDBCreated?: boolean;
  // agreementSignDate?: Date | null = null;
  //recurringBillingDay?: number = 1;
  signature?: string = '';
  isDefaultPractice?: boolean = false;
  widgetDownloadedAt?: string | null = null;
  widgetInstalledAt?: string | null = null;
  isMondayDisabled?: boolean = false;
  isTuesdayDisabled?: boolean = false;
  isWednesdayDisabled?: boolean = false;
  isThursdayDisabled?: boolean = false;
  isFridayDisabled?: boolean = false;
  isSaturdayDisabled?: boolean = false;
  isSundayDisabled?: boolean = false;

  // Data Refresh Configuration fields
  initialDataLoadDate?: string | null = null;
  initialDataLoadTime?: string | null = null;
  initialDataLoadTimezone?: string | null = null;
  initialExtractionUpTo?: string | null = null;
  fullLoadSyncTime?: string | null = null;
  fullLoadSyncTimezone?: string | null = null;
  dailyExtractionForLast?: string | null = null;
  updateFrequencyMinutes?: number | null = null;

  // Configuration timestamps
  pmsConfiguredOn?: string | null = null;
  pmsUpdatedOn?: string | null = null;
  dataRefreshConfiguredOn?: string | null = null;
  dataRefreshUpdatedOn?: string | null = null;

  practiceOnboardingStatusHistory?: PracticeOnboardingStatusHistory[] = [];

  //For Is From Form
  isFromForm?: boolean | null = false;
  sendFormInviteCode?: string | null = '';
  widgetStatus?: number;
  pmsVersionId?: number;
}

export class PracticeOnboardingStatusHistory
{
    onboardingStatus: number = 0;
    onboardingStatusName: string = "";
    details: string = "";
    completedOn: string = "";
    completedBy: number = 0;
    completedByName: string = "";
}

export class UpdateAgreementAcceptanceReq {
  id: number = 0;
  isAgreementAccepted: boolean = false;
  agreementStartDate?: Date | string | null = null;
  agreementEndDate?: Date | string | null = null;
  firstBillingDate?: Date | string | null = null;
  // agreementSignDate?: Date | null = null;
  agreementAcceptedOn?: Date | string | null = null;
  recurringBillingDay?: number = 1;
  signature?: string = '';
  IsFirstAccept: boolean;
}

export class PracticeSummary {
  id: number;
  dbaName: string;
  name: string;
  pmsId: number;
  contactPersonName: string;
  scheduleTime: string;
  logoUrl: string;
  licenseKey: string;
}

export class PracticeList {
  practiceList: PracticeSummary[];
  totalRecords: number;
}

export class AllPracticeListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  CustomerId: number = 0;
}
export class PracticeAccountStatusResponse {
  status: number;
  practiceId: number;
}